const Util = {};
const CONSTS = {
    eId: 'safety',
    prefix: 'user_safety_',
    geometryField: 'geom',
    attributeTag: 'tag'
};
//
function checkSuccess(result) {
    if (result && result.success) {
        return null;
    } else {
        return new Error(result.msg);
    }
}
//展开tag
function flatTag(list) {
    for (let i = 0, len = list.length; i < len; i++) {
        let item = list[i];
        let tag = item.tag;
        delete item.tag;
        for (let k in tag) {
            if (Object.prototype.toString.call(tag[k]) == '[object Object]') {
                item[k] = tag[k].tag;
            } else {
                item[k] = tag[k];
            }
        }
        //id
        item.id = item._id;
        delete item._id;
    }
    return list;
};

//
const MetaCache = {};
/**
 * 获取元数据
 * @param opts
 * @param opts.url
 * @param opts.tables
 * @param opts.eId
 * @param opts.httpRequest
 */
Util.getMetas = function(opts) {
    return new Promise(async(resolve, reject) => {
        let result = new Array(opts.tables.length),
            queryTables = {};
        for (let i = 0; i < opts.tables.length; i++) {
            let table = opts.tables[i];
            if (MetaCache.hasOwnProperty(table)) {
                result[i] = MetaCache[table];
            } else {
                queryTables[table] = i;
            }
        }
        let queryTableNames = Object.keys(queryTables);
        if (queryTableNames.length > 0) {
            let query = {
                "dataSetId": {
                    "$in": queryTableNames
                }
            };
            let url = opts.url + '/dataSet/query';
            let body = {};
            body.eId = CONSTS.eId;
            body.query = JSON.stringify(query);
            let data = await opts.httpRequest.get(url, 'json', body, 'application/x-www-form-urlencoded', {});
            let error = checkSuccess(data);
            if (error == null) {
                let list = data.data.result;
                for (let j = 0; j < list.length; j++) {
                    let metaObj = list[j];
                    let index = queryTables[metaObj.dataSetId];
                    result[index] = metaObj;
                    MetaCache[metaObj.dataSetId] = metaObj;
                }
            } else {
                reject(error);
            }
        }
        resolve(result);
    });
}

/**
 * @param opts
 * @param opts.url
 * @param opts.table
 * @param opts.eId
 * @param opts.httpRequest
 * @param opts.data
 * @param opts.dataParser
 */
Util.query = function(opts) {
    return new Promise(async(resolve, reject) => {
        let url = opts.url + '/dataOperate/query';
        let body = {};
        body.eId = opts.eId || CONSTS.eId;
        body.dataSetId = opts.table;
        for (let k in opts.data) {
            let str = Object.prototype.toString.call(opts.data[k]);
            if (str == '[object Object]' || str == '[object Array]') {
                body[k] = JSON.stringify(opts.data[k]);
            } else {
                body[k] = opts.data[k] || null;
            }
        }
        let data = await opts.httpRequest.post(url, 'json', body, 'application/x-www-form-urlencoded; charset=UTF-8', {});
        let error = checkSuccess(data);
        if (error == null) {
            let result = data.data;
            result.total = result.totalCount;
            delete result.totalCount;
            result.list = flatTag(result.result);
            delete result.result;
            if (opts.dataParser) {
                result = opts.dataParser(result);
            }
            resolve(result);
        } else {
            reject(error);
        }
    });
}

/**
 * @param opts
 * @param opts.url
 * @param opts.eId
 * @param opts.httpRequest
 * @param opts.data
 */
Util.queryMulti = function(opts) {
    return new Promise(async(resolve, reject) => {
        let url = opts.url + '/dataOperate/queryMulti';
        let body = {};
        body.eId = opts.eId || CONSTS.eId;
        body.data = JSON.stringify(opts.data);
        let data = await opts.httpRequest.post(url, 'json', body, 'application/x-www-form-urlencoded; charset=UTF-8', {});
        let error = checkSuccess(data);
        if (error == null) {
            let result = data.data;
            for (let k in result) {
                result[k] = flatTag(result[k]);
            }
            if (opts.dataParser) {
                result = opts.dataParser(result);
            }
            resolve(result);
        } else {
            reject(error);
        }
    });
}

/**
 * 多个管道执行方法-公共
 * @param opts 
 * @param opts.url 
 * @param opts.httpRequest 
 * @param opts.aggregateList 管道列表
 * @param opts.dataParser 
 * @returns {*}
 */
Util.aggregateMulti = function(opts) {
    return new Promise(async(resolve, reject) => {
        let url = opts.url + '/dataStatics/aggregateMulti';
        let body = {};
        body.eId = opts.eId || CONSTS.eId;
        body.data = JSON.stringify(opts.aggregateList);
        let data = await opts.httpRequest.post(url, 'json', body, 'application/x-www-form-urlencoded; charset=UTF-8', {});
        let error = checkSuccess(data);
        if (error == null) {
            let result = data.data;
            for (let k in result) {
                result[k] = flatTag(result[k]);
            }
            if (opts.dataParser) {
                result = opts.dataParser(result);
            }
            resolve(result);
        } else {
            reject(error);
        }
    });
}

//清理缓存
Util.clear = function() {
    for (let k in MetaCache) {
        delete MetaCache[k];
    }
}

module.exports = Util;